// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/generations/v1/list_vision_board_generations.proto (package protos.vision.generations.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { VisionGeneration } from "./vision_generation_pb";
import { file_vision_generations_v1_vision_generation } from "./vision_generation_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/generations/v1/list_vision_board_generations.proto.
 */
export const file_vision_generations_v1_list_vision_board_generations: GenFile = /*@__PURE__*/
  fileDesc("Cjl2aXNpb24vZ2VuZXJhdGlvbnMvdjEvbGlzdF92aXNpb25fYm9hcmRfZ2VuZXJhdGlvbnMucHJvdG8SHHByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEivgIKIUxpc3RWaXNpb25Cb2FyZEdlbmVyYXRpb25zUmVxdWVzdBJWCgZwYXJhbXMYASABKAsyRi5wcm90b3MudmlzaW9uLmdlbmVyYXRpb25zLnYxLkxpc3RWaXNpb25Cb2FyZEdlbmVyYXRpb25zUmVxdWVzdC5QYXJhbXMSXgoKcGFnaW5hdGlvbhgCIAEoCzJKLnByb3Rvcy52aXNpb24uZ2VuZXJhdGlvbnMudjEuTGlzdFZpc2lvbkJvYXJkR2VuZXJhdGlvbnNSZXF1ZXN0LlBhZ2luYXRpb24aHAoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkaQwoKUGFnaW5hdGlvbhIRCglwYWdlX3NpemUYASABKAUSFAoKbmV4dF90b2tlbhgCIAEoCUgAQgwKCnBhZ2VfdG9rZW4i1AIKIkxpc3RWaXNpb25Cb2FyZEdlbmVyYXRpb25zUmVzcG9uc2USVwoGcmVzdWx0GAEgASgLMkcucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5MaXN0VmlzaW9uQm9hcmRHZW5lcmF0aW9uc1Jlc3BvbnNlLlJlc3VsdBJfCgpwYWdpbmF0aW9uGAIgASgLMksucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5MaXN0VmlzaW9uQm9hcmRHZW5lcmF0aW9uc1Jlc3BvbnNlLlBhZ2luYXRpb24aTQoGUmVzdWx0EkMKC2dlbmVyYXRpb25zGAEgAygLMi4ucHJvdG9zLnZpc2lvbi5nZW5lcmF0aW9ucy52MS5WaXNpb25HZW5lcmF0aW9uGiUKClBhZ2luYXRpb24SFwoPbmV4dF9wYWdlX3Rva2VuGAEgASgJYgZwcm90bzM", [file_vision_generations_v1_vision_generation]);

/**
 * @generated from message protos.vision.generations.v1.ListVisionBoardGenerationsRequest
 */
export type ListVisionBoardGenerationsRequest = Message<"protos.vision.generations.v1.ListVisionBoardGenerationsRequest"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Params params = 1;
   */
  params?: ListVisionBoardGenerationsRequest_Params | undefined;

  /**
   * @generated from field: protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Pagination pagination = 2;
   */
  pagination?: ListVisionBoardGenerationsRequest_Pagination | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ListVisionBoardGenerationsRequest.
 * Use `create(ListVisionBoardGenerationsRequestSchema)` to create a new message.
 */
export const ListVisionBoardGenerationsRequestSchema: GenMessage<ListVisionBoardGenerationsRequest> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_vision_board_generations, 0);

/**
 * @generated from message protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Params
 */
export type ListVisionBoardGenerationsRequest_Params = Message<"protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Params.
 * Use `create(ListVisionBoardGenerationsRequest_ParamsSchema)` to create a new message.
 */
export const ListVisionBoardGenerationsRequest_ParamsSchema: GenMessage<ListVisionBoardGenerationsRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_vision_board_generations, 0, 0);

/**
 * @generated from message protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Pagination
 */
export type ListVisionBoardGenerationsRequest_Pagination = Message<"protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Pagination"> & {
  /**
   * @generated from field: int32 page_size = 1;
   */
  pageSize: number;

  /**
   * @generated from oneof protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Pagination.page_token
   */
  pageToken: {
    /**
     * @generated from field: string next_token = 2;
     */
    value: string;
    case: "nextToken";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message protos.vision.generations.v1.ListVisionBoardGenerationsRequest.Pagination.
 * Use `create(ListVisionBoardGenerationsRequest_PaginationSchema)` to create a new message.
 */
export const ListVisionBoardGenerationsRequest_PaginationSchema: GenMessage<ListVisionBoardGenerationsRequest_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_vision_board_generations, 0, 1);

/**
 * @generated from message protos.vision.generations.v1.ListVisionBoardGenerationsResponse
 */
export type ListVisionBoardGenerationsResponse = Message<"protos.vision.generations.v1.ListVisionBoardGenerationsResponse"> & {
  /**
   * @generated from field: protos.vision.generations.v1.ListVisionBoardGenerationsResponse.Result result = 1;
   */
  result?: ListVisionBoardGenerationsResponse_Result | undefined;

  /**
   * @generated from field: protos.vision.generations.v1.ListVisionBoardGenerationsResponse.Pagination pagination = 2;
   */
  pagination?: ListVisionBoardGenerationsResponse_Pagination | undefined;
};

/**
 * Describes the message protos.vision.generations.v1.ListVisionBoardGenerationsResponse.
 * Use `create(ListVisionBoardGenerationsResponseSchema)` to create a new message.
 */
export const ListVisionBoardGenerationsResponseSchema: GenMessage<ListVisionBoardGenerationsResponse> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_vision_board_generations, 1);

/**
 * @generated from message protos.vision.generations.v1.ListVisionBoardGenerationsResponse.Result
 */
export type ListVisionBoardGenerationsResponse_Result = Message<"protos.vision.generations.v1.ListVisionBoardGenerationsResponse.Result"> & {
  /**
   * @generated from field: repeated protos.vision.generations.v1.VisionGeneration generations = 1;
   */
  generations: VisionGeneration[];
};

/**
 * Describes the message protos.vision.generations.v1.ListVisionBoardGenerationsResponse.Result.
 * Use `create(ListVisionBoardGenerationsResponse_ResultSchema)` to create a new message.
 */
export const ListVisionBoardGenerationsResponse_ResultSchema: GenMessage<ListVisionBoardGenerationsResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_vision_board_generations, 1, 0);

/**
 * @generated from message protos.vision.generations.v1.ListVisionBoardGenerationsResponse.Pagination
 */
export type ListVisionBoardGenerationsResponse_Pagination = Message<"protos.vision.generations.v1.ListVisionBoardGenerationsResponse.Pagination"> & {
  /**
   * @generated from field: string next_page_token = 1;
   */
  nextPageToken: string;
};

/**
 * Describes the message protos.vision.generations.v1.ListVisionBoardGenerationsResponse.Pagination.
 * Use `create(ListVisionBoardGenerationsResponse_PaginationSchema)` to create a new message.
 */
export const ListVisionBoardGenerationsResponse_PaginationSchema: GenMessage<ListVisionBoardGenerationsResponse_Pagination> = /*@__PURE__*/
  messageDesc(file_vision_generations_v1_list_vision_board_generations, 1, 1);

